import cx from 'classnames';
import { connect, getIn } from 'formik';
import omit from 'lodash.omit';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Notification } from '@snsw/react-component-library';

export const WithWrapper = (component = 'input') => WrappedComponent => {
  const Label = props => {
    const [hideLabel] = useState(false);

    const {
      formik,
      name,
      label,
      placeholder,
      type,
      disabled,
      required,
      style,
      className,
      format,
    } = props;

    const { touched, errors, values } = formik;

    const error = getIn(errors, name);
    const touch = getIn(touched, name);
    const value = getIn(values, name);
    const hide = hideLabel || !!value || !!placeholder || !!(disabled && value);
    const hidden = type && type === 'hidden';
    const errormsg = touch && error ? error : null;

    const passableProps = omit(props, ['hint', 'label', 'style']);

    return (
      <>
        <div
          className={cx(`${component}-wrapper`, className, {
            hidden,
          })}
          style={style}
        >
          {label && (
            <label className={cx('label', { hide })} htmlFor={`${name}`}>
              {`${label}${required ? ' *' : ''}`}
            </label>
          )}
          <WrappedComponent
            // onAnimationStart={handleAutoFill}
            // onFocus={handleFocus}
            // onBlur={handleBlur}
            {...passableProps}
            errormsg={errormsg}
          />
          {!!errormsg && <Notification variant="error" title={errormsg}></Notification>}
        </div>
      </>
    );
  };

  Label.propTypes = {
    formik: PropTypes.instanceOf(Object).isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    hint: PropTypes.string,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    style: PropTypes.instanceOf(Object),
    format: PropTypes.string,
  };

  Label.defaultProps = {
    label: null,
    hint: null,
    placeholder: null,
    type: null,
    disabled: false,
    required: false,
    style: {},
  };

  return connect(Label);
};

export default WithWrapper;
